export function getBuilderOnlineStatusText(isOnline: boolean) {
  return isOnline ? 'Свяжитесь с застройщиком, пока он в сети' : 'Свяжитесь с застройщиком';
}
